<template lang="html">
  <div class="controller">
    <v-row justify="center">
      <v-col cols="8">
        <v-text-field
          v-model="num"
          label="A kijelzett szám"
          type="number"
          min=0
          max=99999999
          :counter="8"
        ></v-text-field>
        <v-btn @click="resetSoroban" class="warning">Lenulláz</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed:{
    num:{
      get(){
        return this.$store.getters.displayNumber
      },
      set(newValue){
        newValue = newValue*1; //get a number
        this.$store.dispatch('setDisplayNumber', newValue)
      }
    }
  },
  methods:{
    resetSoroban(){
      this.num = 0;
    },
  },
}
</script>

<style lang="scss" scoped>
.controller{
  margin-top: 70px;

  .v-input{
    font-size: 2rem;
    input{
      max-height: 50px;
    }
  }
}
</style>
